export default {
  items: [],
  pagination: {},
  size: 15,
  isBusy: false,
};
